import { useState } from 'react'

import { Input, LegacyPage, Stack, Form } from 'peach/components'

const ScratchContext = () => {
  const [val, setVal] = useState({
    upperValueA: 'A Value',
    upperValueB: 'B Value',
    nestedObjects: [
      {
        lowerValueC: 'C Value',
        aNestedObject: {
          lowestValueD: 'D Value',
          lowestValueE: 'E Value',
        },
      },
      {
        lowerValueC: 'C Value',
        aNestedObject: {
          lowestValueD: 'D Value',
          lowestValueE: 'E Value',
        },
      },
    ],
  })

  return (
    <LegacyPage.Full>
      <Stack>
        <Form.Provider onChange={setVal} value={val}>
          <Form.Row>
            <Input formKey='upperValueA' />
            <Input formKey='upperValueB' />
          </Form.Row>
          <Form.List formKey='nestedObjects'>
            <Input formKey='lowerValueC' />
            <Form.Provider formKey='aNestedObject' section>
              <Input formKey='lowestValueD' />
            </Form.Provider>
          </Form.List>
        </Form.Provider>
      </Stack>
    </LegacyPage.Full>
  )
}

export default ScratchContext
